<template>
    <div>
        <group-card title="Document Type" icon="attach_file" padded>
            <template slot="actions">
                <md-button class="md-icon-button md-primary md-simple new-app-button" @click="$router.push('/administration/system_general/document_type/new')" >
                  <md-icon id="new-app-icon">note_add</md-icon>
                    Add New
                  <md-tooltip md-direction="top">New Document Type</md-tooltip>
                </md-button>
                <loading-icon-button
                @click="getDocumentTypeList()"
                tooltip="Refresh"
                :loading="progress_indicator.lender_list"
                >
                cached
                </loading-icon-button>
            </template>
            <div data-app>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="documentTypeHeaders"
          :items="document_type_items"
          :search="search"
          item-key="name"
          :items-per-page="10"
          class="elevation-0 broker_table"
          :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'first_page',
                    lastIcon: 'last_page',
                    prevIcon: 'skip_previous',
                    nextIcon: 'skip_next'}"
          loading
          loading-text="Loading... Please wait"
        >
          <template v-slot:item.active="{ item }">
            <md-button class="md-just-icon md-primary md-simple" v-if="item.active == '1'"
                       >
              <md-icon>done</md-icon>

            </md-button>
            <md-button class="md-just-icon md-primary md-simple" v-else
                       >
              <md-icon>close</md-icon>

            </md-button>
          </template>

          <template v-slot:item.require_authentication="{ item }">
            <md-button class="md-just-icon md-primary md-simple" v-if="item.require_authentication == '1'"
                       >
              <md-icon>done</md-icon>

            </md-button>
            <md-button class="md-just-icon md-primary md-simple" v-else
                       >
              <md-icon>close</md-icon>

            </md-button>
          </template>


          <template v-slot:item.actions="{ item }">
            <loading-icon-button
              @click="viewDocumentType(item)"
              tooltip="Open"
            >
              launch
            </loading-icon-button>
          </template>
        </v-data-table>
      </div>
        </group-card>
    </div>
</template>
<script>
import filters from "@/components/utils/filters";
import {GroupCard} from "@/components";
import {mapGetters} from "vuex";
import LoadingIconButton from '@/components/LoadingIconButton';
import ValidatedTextInput from "../ValidatedInput/ValidatedTextInput";
import LoadingIconTextButton from "../LoadingIconTextButton";
import WaitingDialog from "../Dialogs/WaitingDialog";
import ConfirmDialog from "../Dialogs/ConfirmDialog";

export default {
  components: {
    LoadingIconTextButton,
    ValidatedTextInput,
    GroupCard,
    LoadingIconButton,
  },
  data() {
    return {
      search: '',
      progress_indicator: {
        lender_list: false,
      },
      documentTypeHeaders: [
        {
          text: "ID",
          align: 'center',
          sortable: true,
          value: 'id'
        },
        {text: 'Document Name', value: 'name', align: 'start', width: '20%'},
        {text: 'Description', value: 'description', align: 'start', width: '20%'},
        {text: 'Accepted File Type', value: 'accepted_file_types', align: 'center'},
        {text: 'Active', value: 'active', align: 'center'},
        {text: 'Required Authentication', value:'require_authentication', align: 'center'},
        {text: 'Action', value: 'actions', align: 'center'},
      ],
      document_type_items: [],
      app_ids: "",
      currentId: "",
      showAssessmentTool: false,
    }
  },
  methods: {
    async toggleFlag(id, type, flag) {
      this.progress_indicator.lender_list = true;
      await this.$store.dispatch('toggle_lender_setting', {
        id: id,
        flag: flag,
        type: type,
      });
      this.getLenders(true);
      this.progress_indicator.lender_list = false;
    },
    async refreshBA() {
      //break app_ids based on ,
      let app_ids = this.app_ids.split(",");
      this.showProcessDialog("Processing...", "Please wait whilst the assessment results are being refreshed.");
      for (const id of app_ids) {
        this.currentId = id;
        await axios.post('/api/v1/assessment/batch/refresh', {
          application_id: id,
        });
      }
      if (this.$modal.submit) {
        this.$modal.submit();
        await this.showProcessDialog("Success", "The assessment results have been refreshed.", "confirm");
      }
    },
    async getDocumentTypeList(force = false) {
      this.progress_indicator.lender_list = true;
      let response = await this.$store.dispatch('fetch_document_type_list', force);
      this.document_type_items = response;
      this.progress_indicator.lender_list = false;
    },
    viewDocumentType(item){
      this.$router.push(`/administration/system_general/document_type/${item.id}/view`);
    },
    async showProcessDialog(title, message, type = "waiting") {
      if (type == "waiting") {
        this.$modal.show(WaitingDialog, {
          title: title,
          message: message,
        });
      }
      if (type == "confirm") {
        this.$modal.show(ConfirmDialog, {
          title: title,
          message: message,
          confirmText: "Close",
        })
      }
    },
  },
  mounted() {
    this.getDocumentTypeList();
  },
  computed: {
    ...mapGetters({
      savedBrokers: 'administrationBrokers',
    }),
  },
  filters: {
    ...filters,
  }
}
</script>

<style lang="scss" scoped>
.broker_table {
  table {
    td {
      text-align: center;
    }
  }

  .v-data-footer__select {
    display: none;
  }
}
</style>
